import { RawHtml } from "../../../../lib/ReactUtils";
import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles((theme) => ({
  pathStyle: { fill: theme.avatarColor },
}));

const Avatar = ({ customAvatar }) => {
  const styles = useStyles();
  return customAvatar ? (
    <RawHtml className={styles.image} tag={"span"}>
      {customAvatar}
    </RawHtml>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="29"
      viewBox="0 0 22 29"
      fill="none"
    >
      <ellipse cx="11" cy="28" rx="8" ry="1" fill="black" fillOpacity="0.15" />
      <circle
        className={styles.pathStyle}
        r="11"
        transform="matrix(-1 0 0 1 11 11)"
      />
      <circle cx="11" cy="10" r="2" fill="#F8F9FF" />
      <circle cx="18" cy="10" r="2" fill="#F8F9FF" />
    </svg>
  );
};

export default Avatar;
